import { useQuery } from "@tanstack/react-query";
import { searchPastProjects } from "../key-personnel-api";

export const usePastProjectSearch = (
	search: string,
	enabled: boolean
) => {
	return useQuery({
		queryKey: ["key-personnel", "past-projects", search],
		queryFn: () => searchPastProjects({ search, page_size: 5 }),
		enabled: enabled && search.length >= 2,
		staleTime: 30_000,
		placeholderData: (previousData) => previousData,
	});
};
